import { Media } from '@/interfaces/cms';

import { getCmsBaseUrl, getCmsMediaBaseUrl } from './ssrUtils';

export const getMediaUrlForSize = (
  media: Media | number,
  size: keyof Required<Media>['sizes'],
) => {
  if (typeof media === 'number') {
    return undefined;
  }

  const mediaSize = media.sizes?.[size];

  if (mediaSize?.url) {
    return getMediaUrl(mediaSize);
  }

  return `${getCmsBaseUrl()}${media.url}`;
};

export const getMediaUrl = (
  media:
    | { filename?: string | undefined | null; url?: string | undefined | null }
    | number,
) => {
  if (typeof media === 'number') {
    return undefined;
  }

  const mediaBaseUrl = getCmsMediaBaseUrl();

  if (mediaBaseUrl) {
    return `${mediaBaseUrl}/${media.filename}`;
  }

  return `${getCmsBaseUrl()}${media.url}`;
};
